export class PeliculaHorario {
  public id: number;
  public tipo_id: number;
  public espacio_id: number;
  public pelicula_id: number;
  public programacion_id: number;
  public fecha: string;
  public hora: string;
  public subtitulo: boolean;
  constructor() { }
}
